import { styled } from "styled-components";

import { useTranslate } from "common/utilities/useTranslate";
import { KeyIssueCopyrightText } from "domains/topicDetail/components/KeyIssueCopyrightText";
import { StyledText, TMCopyrightText } from "domains/topicDetail/components/TMCopyrightText";
import { getTopicCurator } from "domains/topicDetail/utils";
import type { Topic } from "entities/topics/types";

const StyledSubTitle = styled.p`
  margin: 0.6rem 0rem 0.4rem 0;
  font-size: 1rem;
  line-height: 19px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.fillPrimary};
`;

const StyledTMCopyrightText = styled(TMCopyrightText)`
  font-size: 0.9rem;
  line-height: 19px;
  ${StyledText} {
    margin: 0 0 5px 0;
  }
`;

type TopicDetailCurationProps = { keyIssue?: Topic; topic: Topic };

export const TopicDetailCuration = ({ topic, keyIssue }: TopicDetailCurationProps) => {
  const translate = useTranslate();

  return (
    <>
      <StyledSubTitle>{translate("app.topic.curation")}</StyledSubTitle>
      {keyIssue ? (
        <KeyIssueCopyrightText keyIssue={keyIssue} topic={topic} />
      ) : (
        <StyledTMCopyrightText topic={topic} creator={getTopicCurator(topic)} />
      )}
    </>
  );
};
